import Vue from 'vue';
import VueRouter from 'vue-router';
import Settings from '../views/Settings.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Timer Settings',
    component: Settings,
  },
  {
    path: '/timer',
    name: 'timer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Timer.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "about" */ '../views/Settings.vue'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
